// Plain-language labels for the Sidekick usage page. The audience includes
// non-technical staff, so API codes are never shown on their own.

import moment from "moment";
import {
  Asker,
  Client,
  RatingFilter,
  TurnFlag,
  UserKind,
} from "../../types/api/sidekick-usage.type";

export const ASKER_OPTIONS: { value: Asker; label: string }[] = [
  { value: "all", label: "Everyone" },
  { value: "customer", label: "Customers only" },
  { value: "staff", label: "ControlRooms staff only" },
];

export const RATING_OPTIONS: { value: RatingFilter; label: string }[] = [
  { value: "up", label: "Thumbs up" },
  { value: "down", label: "Thumbs down" },
  { value: "none", label: "Not rated" },
];

export const FLAG_OPTIONS: { value: TurnFlag; label: string }[] = [
  { value: "budget_exceeded", label: "Ran out of tool budget" },
  { value: "answer_guard", label: "Answer guard warning" },
  { value: "chart", label: "Included a chart" },
];

// Select menus use "any" as the "no filter" choice; it maps to "" in the URL.
export const HAS_COMMENT_OPTIONS = [
  { value: "any", label: "Any" },
  { value: "true", label: "Has a comment" },
  { value: "false", label: "No comment" },
];

export const CLIENT_OPTIONS = [
  { value: "any", label: "Any" },
  { value: "web", label: "Web" },
  { value: "ios", label: "iPhone app" },
];

export const CLIENT_LABELS: Record<Client, string> = {
  web: "Web",
  ios: "iPhone app",
};

export const USER_KIND_LABELS: Record<UserKind, string> = {
  customer: "Customer",
  staff: "ControlRooms staff",
  unknown: "Unknown",
};

export const formatDateTime = (iso: string | null | undefined): string => {
  if (!iso) return "—";
  const m = moment(iso);
  return m.isValid() ? m.format("MMM D, YYYY HH:mm") : iso;
};

export const formatLatency = (ms: number | null | undefined): string => {
  if (ms === null || ms === undefined) return "—";
  if (ms < 1000) return `${Math.round(ms)} ms`;
  return `${(ms / 1000).toFixed(1)} s`;
};

export const formatCount = (n: number | null | undefined): string =>
  n === null || n === undefined ? "—" : n.toLocaleString("en-US");
